import React from 'react';
import { ChevronDown, HardHatIcon } from 'lucide-react';
import { BoardConfig } from '../../models/appState';
import { getIconComponent } from '../../utils/icon';
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
} from '@/components/ui/dropdown-menu';
import BoardTypeDropdownItem from './BoardTypeDropdownItem';

interface BoardTypeDropdownProps {
    boards: BoardConfig[];
    currentBoard?: BoardConfig;
    boardType: string;
    colorCode: string;
    onBoardTypeChange: (type: string) => void;
}

const BoardTypeDropdown: React.FC<BoardTypeDropdownProps> = ({
    boards,
    currentBoard,
    boardType,
    colorCode,
    onBoardTypeChange,
}) => {
    const titleColorClass = `text-${colorCode}-800`;
    const iconColorClass = `text-${colorCode}-600`;
    const BoardIconComponent = currentBoard?.uiConfig ?
        getIconComponent(currentBoard?.uiConfig) ?? HardHatIcon : HardHatIcon;
    const buttonClass = `flex items-center gap-2 px-3 py-1.5 h-9 rounded-full border bg-white shadow-sm hover:bg-gray-50 transition-all duration-200 ${titleColorClass}`;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button className={buttonClass}>
                    <BoardIconComponent className={`h-4 w-4 ${iconColorClass}`} />
                    <span className="text-xs md:text-sm font-medium">
                        {currentBoard ? currentBoard.title : ''}
                    </span>
                    <ChevronDown className="h-4 w-4 transition-transform" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-48">
                {boards.map((board) => (
                    <BoardTypeDropdownItem
                        key={board.key}
                        board={board}
                        boardType={boardType}
                        onSelect={onBoardTypeChange}
                    />
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default BoardTypeDropdown;
